import { Component, EventEmitter, OnInit, Input, Output } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { SpinnerService } from "shared-components";
import { EtiquetadoService } from "../../../../services/etiquetado.service";
import { Subject } from 'rxjs';
import { DataProvider } from "projects/packcert-web/src/app/providers/data.provider";
import { SessionContextService } from "projects/packcert-web/src/app/context/session-context.service";

@Component({
    selector: 'app-dsg-new-edit-almacenes',
    templateUrl: './new-edit.component.html'
})
export class AlmacenesDesignacionNewEditComponent implements OnInit {

    public newEditForm: UntypedFormGroup;
    public showError = false;
    public deleteModal = false;
    private _editable: boolean;
    private _toDelete: any;
    public desAlmacen;

    public disabledAlmacenes: Subject<boolean> = new Subject();

    get editable(): boolean { return this._editable; }
    @Input() set editable(value: boolean) {
        this._editable = value;
        if (this.newEditForm) {
            if (value) {
                this.newEditForm.enable();
                this.disabledAlmacenes.next(false);
            }
        }
    }
    @Input() almacenesList?;
    @Input() designacionAlmacen?;
    @Input() designacionesAlmacen?;
    @Input() designacionId;

    @Output() refresh = new EventEmitter<boolean>();
    @Output() pushMessage = new EventEmitter<string>();
    @Output() editableChanged = new EventEmitter<any>();
    @Output() close = new EventEmitter<boolean>();

    constructor(
        private _fb: UntypedFormBuilder,
        private readonly _sessionContext: SessionContextService,
        private readonly _etiquetadoService: EtiquetadoService,
        private readonly _spinnerService: SpinnerService,
        private readonly _dataProvider: DataProvider
    ) {}

    ngOnInit() {
        this.newEditForm = this._fb.group({
            id: [{value: '', disabled: !this.editable}],
            desAlmacen: [{value: '', disabled: !this.editable}, Validators.required]
        });

        if (this.designacionAlmacen) {
            this.getAlmacen();
        }

        if (this.designacionesAlmacen && this.almacenesList) {
            for (let designacionAlmacen of this.designacionesAlmacen) {
                if (this.almacenesList.find(x => x.id === designacionAlmacen.almacenId)) {
                    const index = this.almacenesList.indexOf(this.almacenesList.find(x => x.id === designacionAlmacen.almacenId));
                    if (index > -1) {
                        this.almacenesList.splice(index, 1);
                    }
                }
            }
        }
    }

    public get role() {
        return this._sessionContext.sessionUser.role;
    }

    public get claims() {
        return this._sessionContext.sessionUser.lsClaimTypes;
    }

    public getAlmacen() {
        this._spinnerService.showSpinner();
        this._etiquetadoService.getAlmacen(this.designacionAlmacen.almacenId).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            this.newEditForm.get('id').patchValue(resp.id); 
            this.newEditForm.get('desAlmacen').patchValue(resp);
        });
    }

    public save() {
        this.checkForm();
        if (this.newEditForm.valid) {
            const newDesignacionAlmacen = {
                designacionId: this.designacionId,
                almacenId: this.newEditForm.get('desAlmacen').value.id
            };
            this._etiquetadoService.createDesignacionesAlmacen(newDesignacionAlmacen).toPromise().finally(() => {
            }).then(() => {
              this.refresh.emit(true);
              this.newEditForm.disable();
              this.disabledAlmacenes.next(true);
              this.pushMessage.emit('global.success.itemCreated');
            });
        }
    }

    public askDelete(designacionAlmacen) {
        this._toDelete = designacionAlmacen;
        this.deleteModal = true;
    }

    public delete() {
        this._spinnerService.showSpinner();
        this._etiquetadoService.deleteDesignacionAlmacen(this._toDelete).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then(() => {
          this.closeModal();
          this.refresh.emit(true);
          this.pushMessage.emit('global.success.itemDeleted');
        });
    }

    public closeModal() {
        this.deleteModal = false;
        this._toDelete = '';
    }

    public cancel() {
        if (!this.designacionAlmacen) {
            this.close.emit(false);
        } else {
            this.editableChanged.emit();
        }
    }

    private checkForm() {
        this.showError = this.newEditForm.invalid;
        if (this.showError) {
            this.pushMessage.emit('global.error.required');
        }
    }
}
